var React = require('react');

function Retour (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.25 12.0004L9.50029 5H12.0003L7.50029 11H20V13H7.49971L11.9997 19H9.49971L4.25 12.0004Z","fill":"currentColor"}));
}

Retour.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Retour;

Retour.default = Retour;
